import axios from 'axios'
import constants from '../constants'

const FAVORITE_ASSETS_PATH = `${constants.urlPrefix}/api/favorite-assets`;

const getFavoriteAssets = function (memberId) {
    return axios.get(`${FAVORITE_ASSETS_PATH}/member/${memberId}`);
};

const getFavoriteAssetsByType = function (memberId, type) {
    return axios.get(`${FAVORITE_ASSETS_PATH}`, { params: { memberId, type } });
};

const createFavoriteAsset = function (memberId, assetId, type) {
    return axios.post(`${FAVORITE_ASSETS_PATH}`, { memberId, assetId, type });
};

const removeFavoriteAsset = function (assetId, memberId) {
    return axios.delete(`${FAVORITE_ASSETS_PATH}`, { params: { assetId, memberId } });
};

export default {
    getFavoriteAssets,
    getFavoriteAssetsByType,
    createFavoriteAsset,
    removeFavoriteAsset
}
